import { createBrowserRouter } from "react-router-dom"
import Explore from "@/pages/user/explore"
import Detail from "@/pages/user/post/detail"
import { show as showPost } from "@/routes/loader/post"
import { show as showProfile } from "@/routes/loader/profile"
import Profile from "@/pages/user/profile"
import Login from "@/pages/auth/login"
import Register from "@/pages/auth/register"
import GuestRoute from "@/routes/middleware/guest"
import ProtectedRoute from "@/routes/middleware/protected"
import Category from "@/pages/user/category"

export const router = createBrowserRouter([
    // Guest
    {
        path: "/login",
        element: (
            <GuestRoute>
                <Login />
            </GuestRoute>
        )
    },
    {
        path: "/register",
        element: (
            <GuestRoute>
                <Register />
            </GuestRoute>
        )
    },

    // Protected
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <Explore />
            </ProtectedRoute>
        )
    },
    {
        path: "/category",
        element: (
            <ProtectedRoute>
                <Category />
            </ProtectedRoute>
        )
    },
    {
        path: "/category/:slug",
        element: (
            <ProtectedRoute>
                <Explore filtered={true} />
            </ProtectedRoute>
        )
    },
    {
        path: "/post/:id",
        element: (
            <ProtectedRoute>
                <Detail />
            </ProtectedRoute>
        ),
        // loader: showPost
    },
    {
        path: "/profile",
        element: (
            <ProtectedRoute>
                <Profile />
            </ProtectedRoute>
        ),
        loader: showProfile
    }
])